'use client';
import ProgressIndicator from './_components/progress-indicator';
import { FinancialStatusProvider } from './_components/context/financial-status-context';
import ToggleLanguage from './_components/toggle-language';
import HeaderSection from './_components/header-section';
import FormController from './_components/_formComponents/form-controller';
import MobileProgressIndicator from './_components/mobile-progress-indicator';

export default function page() {
	return (
		<main className="px-5">
			<FinancialStatusProvider>
				<div className="hidden md:block">
					<HeaderSection />
				</div>

				<div className="mx-auto mt-4 flex max-w-7xl justify-between px-5 md:px-0 lg:block">
					<ToggleLanguage />
					<div className="block lg:hidden">
						<MobileProgressIndicator />
					</div>
				</div>
				<div className="mx-auto mt-10 flex max-w-7xl px-5 md:mt-10">
					<div className="hidden w-56 whitespace-nowrap border-r-2 pr-10 lg:block">
						<ProgressIndicator />
					</div>
					<div className="min-h-96 grow md:mx-5 md:min-h-32">
						<FormController />
					</div>
				</div>
			</FinancialStatusProvider>
		</main>
	);
}
